<script>
  import {
    totalPopulationDistricts,
    InsightsRadioCheck,
    totalJobsDistricts,
  } from "../../store.js";

  function reformatNumbers(value) {
    if (value > 1000000) {
      return String(Math.round(value / 1000000)) + "M";
    } else if (value > 1000) {
      return String(Math.round(value / 1000)) + "K";
    } else {
      return String(Math.round(value));
    }
  }
</script>

<div class="results">
  <div>
    Residents in operation zone:

    <div
      class="populationResults"
      style={`color: ${
        $InsightsRadioCheck == "SP"
          ? "#45bcbb"
          : $InsightsRadioCheck == "OZP"
            ? "#0a6a5b"
            : $InsightsRadioCheck == "LP"
              ? "#D9484D"
              : "white"
      }`}
    >
      {reformatNumbers($totalPopulationDistricts)}
    </div>
  </div>
  <br />
  <div>
    Workers in operation zone:

    <div
      class="populationResults"
      style={`color: ${
        $InsightsRadioCheck == "SP"
          ? "#45bcbb"
          : $InsightsRadioCheck == "OZP"
            ? "#0a6a5b"
            : $InsightsRadioCheck == "LP"
              ? "#D9484D"
              : "white"
      }`}
    >
      {reformatNumbers($totalJobsDistricts)}
    </div>
  </div>
</div>

<style>
  .populationResults {
    text-align: center;
    margin: auto;
    width: 80%;
    top: 5px;
    position: relative;
    border-radius: 10px;
    font-size: 40px;
    font-weight: 700;
    background-color: white;
  }
  .results {
    top: 12px;
    position: relative;
    margin: 10px;
    font-size: 14px;
  }
</style>
